import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Legacy Settings route - redirects to new Admin Console
 * Old route: /admin-console
 * New route: /admin/console
 */
const Settings = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace('/admin/console');
  }, [history]);

  return null;
};

export default Settings;
